/*
  This file is linking the front-end events with the JS logic in mwl-core.js
*/
import { MeowLightbox } from './MeowLightbox';
import { render } from 'preact';
import { MeowLightboxContextProvider } from './context';

import PhotoSwipeCore from './photoswipe/core';

/**
 * After a small timeout to ensure most things are loaded.
 */



const renderMeowLightbox = () => {

  const engine = window.mwl_settings.settings.engine;

  // Delete any existing root
  const existingRoot = document.getElementById('mwl-root');
  if ( existingRoot ) {
    existingRoot.parentNode.removeChild(existingRoot);
  }

  document.body.appendChild(document.createRange().createContextualFragment('<div id="mwl-root"></div>'));

  const infiniteScrollElements = document.querySelectorAll('.mgl-infinite-scroll');
  const infiniteScrollableGalleries = Array.from(infiniteScrollElements).map((node) => node.previousSibling);

  if ( engine === 'photoswipe' ) {
    render(<PhotoSwipeCore />, document.getElementById('mwl-root'));
  }

  if ( engine === 'default' ) {

    render(<MeowLightboxContextProvider
      infiniteScrollableGalleries={infiniteScrollableGalleries}
    >
      <MeowLightbox />
    </MeowLightboxContextProvider>, document.getElementById('mwl-root'));
  }
}

document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    renderMeowLightbox();
  }, 300);
});

window.renderMeowLightbox = renderMeowLightbox;

/*
// Tester for AJAX modified content
window.addEventListener('load', () => {
  setTimeout(() => {
    // Remove image
    const $image = document.querySelector('.wp-image-32')
    $image.parentNode.removeChild($image)

    // Add new image
    const $entryContent = document.querySelector('.entry-content')
    const $fakeImage = document.createElement('img')
    $fakeImage.setAttribute('src', 'http://plugins.local/wp-content/uploads/2021/01/58202320191120-768x1024.jpg')
    $entryContent.appendChild($fakeImage)


    document.body.dispatchEvent(new Event('post-load'))
  }, 1000)
})
*/